module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/extroversion/cb9be756683aff63c2ef01d5a8aeb8f3.png";